import { cn } from "@/lib/chillnn/cn";

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/input/select";

import { FormErrorMessage, FormItem, FormLabel } from "../../_base/form";

import type { FormOptionType } from "../../_types/type";

type SelectFieldProps<T> = {
	value: T;
	placeholder?: string;
	options: FormOptionType[];
	handleValueChange: (value: string) => void;
	disabled?: boolean;

	errorMessage?: string;
	label?: string;

	className?: string;
};

export const SelectField = <T,>({
	value,
	placeholder,
	options,
	handleValueChange,
	disabled = false,
	errorMessage,
	label,
	className,
}: SelectFieldProps<T>): JSX.Element | null => {
	return (
		<FormItem>
			<FormLabel>{label}</FormLabel>

			<div className="relative">
				<Select onValueChange={handleValueChange} value={String(value)}>
					<div className={cn("w-full min-w-[110px]", className)}>
						<SelectTrigger disabled={disabled}>
							<SelectValue placeholder={placeholder} />
						</SelectTrigger>
					</div>
					<SelectContent>
						{options.map((item) => {
							if (!String(item.value)) return null;

							return (
								<SelectItem value={String(item.value)} key={item.id} disabled={item.disabled}>
									{String(item.label)}
								</SelectItem>
							);
						})}
					</SelectContent>
				</Select>
				<FormErrorMessage>{errorMessage}</FormErrorMessage>
			</div>
		</FormItem>
	);
};
